import { render, staticRenderFns } from "./CompanyPayments.vue?vue&type=template&id=721d8dea&"
import script from "./CompanyPayments.vue?vue&type=script&lang=js&"
export * from "./CompanyPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports